import React, { Fragment, useEffect, useState } from "react";
import { GetData, getOrderDetails, payGhest } from "./Components/Services";
import { Helmet } from "react-helmet";
import Loading from "../../../Common/Components/Loading";
import VerticalCard from "./Components/VerticalCard";
import Table from "./Components/Table";
import {
  lastReserveForm,
  detailsReserveForm,
  sansDetailsReserveForm,
  detailsData,
  detailsManagerData,
  detailsReserveFormDate,
  detailsDataWallet,
} from "./Components/Forms";
import { CostRender, ToDateJalali } from "../../../Common/Function/index";
import Footer from "./Components/Footer";
import OrderList from "../../../Common/Components/OrlderList";
import { useNavigate } from "react-router-dom";

function User() {
  const initialState = {
    loading: true,
    data: null,
  };
  const [state, setstate] = useState(initialState);
  const navigate = useNavigate();
  useEffect(() => {
    Handler();
  }, []);
  const store = async (data) => {
    setstate({ ...state, loadingReserve: true });
    await payGhest(data).then(() => {
      setstate({ ...state, loadingReserve: false });
    });
  };
  const Handler = (data = null) => {
    setstate({ ...state, loading: true });
    GetData(data).then((result) => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | داشبورد کاربری</title>
      </Helmet>
      <div className="">
        <div className="card-body">
          {state.loading ? (
            <Loading count={1} col={12} height={400} />
          ) : (
            <Fragment>
              <div className="row">
                <VerticalCard
                  value={CostRender.format(state.data && state.data.Wallet)}
                  src={window.origin + "/img/wallet.png"}
                  title={"کیف پول"}
                  amount="تومان"
                />
                <VerticalCard
                  value={0}
                  src={window.origin + "/img/score.png"}
                  title={"امتیاز شما"}
                />
                <VerticalCard
                  value={state.data.ticket_count}
                  src={window.origin + "/img/help.png"}
                  title={"تیکت های فعال"}
                />
                <VerticalCard
                  value={state.data.reserve_count}
                  src={window.origin + "/img/reserve.png"}
                  title={"تعداد سفارشات"}
                />
              </div>
              {state && state.data && state.data.conghset && (
                <div className="row ">
                  <Table
                    title={"صورتحساب قراداد ها"}
                    lastText={""}
                    textEmpty={"صورتحسابی ندارید"}
                    col="col-12"
                    form={[
                      { key: "item_name", name: "نام مجموعه" },
                      { key: "trackingcodeorder", name: "کد پیگیری" },
                      { key: "price", name: "مبلغ قابل پرداخت" },
                      {
                        key: "pay_exp_time",
                        name: "مهلت پرداخت",
                        format: "date",
                      },
                    ]}
                    data={state.data.conghset}
                    to={"/User/Reserves"}
                    btn={{
                      text: "پرداخت صورتحساب",
                      metod: (tr) => {
                        navigate(
                          "/User/renewaltermcontract/" + tr.trackingcodeorder
                        );
                      },
                      loading: state.loadingReserve,
                    }}
                  />
                </div>
              )}
              <div className="col-12 p-0 mt-4">
                <div className="row">
                  <div className="col">
                    <h5>آخرین سفارشات</h5>
                  </div>
                </div>
                <OrderList short={5} />
              </div>

              <Footer />
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
}

export default User;

const UserInfon = ({ data }) => {
  return (
    <div>
      <div className="d-flex justify-content-between form-control mt-2">
        <span>نام خانوادگی</span>
        <span>{data && data.fullname}</span>
      </div>
      <div className="d-flex justify-content-between form-control mt-2">
        <span>شماره موبایل</span>
        <span>{data && data.mobile}</span>
      </div>
      <div className="d-flex justify-content-between form-control mt-2">
        <span>کد ملی</span>
        <span>{data && data.national_code}</span>
      </div>
    </div>
  );
};
const ClassInfo = ({ data }) => {
  return (
    <div>
      <div className="d-flex justify-content-between form-control mt-2">
        <span>نام کلاس</span>
        <span>{data && data.name}</span>
      </div>
      <div className="d-flex justify-content-between form-control mt-2">
        <span>قیمت کلاس</span>
        <span>{data && data.price.price}</span>
      </div>
      <div className="d-flex justify-content-between form-control mt-2">
        <span>تاریخ شروع</span>
        <span>{ToDateJalali(data && data.start_date)}</span>
      </div>
      <div className="d-flex justify-content-between form-control mt-2">
        <span>نحوه برگزاری</span>
        <span>{data && data.type == "online" ? "مجازی" : "حضوری"}</span>
      </div>
    </div>
  );
};

const OrderInfo = ({ data }) => {
  return (
    <div>
      <div className="d-flex justify-content-between form-control mt-2">
        <span>مبلغ پرداختی</span>
        <span>{data && data.total_price}</span>
      </div>
      <div className="d-flex justify-content-between form-control mt-2">
        <span>کد پیگیری سفارش </span>
        <span>{data && data.trackingcodeorder}</span>
      </div>
    </div>
  );
};
const OtherUserInfo = ({ data }) => {
  return data.map((user, coutn) => {
    if (user.type != "self") {
      return (
        <div key={coutn}>
          <div className="d-flex justify-content-between form-control mt-2">
            <span> نام خانوادگی همراه</span>
            <span>{data && data.fullname}</span>
          </div>

          <div className="d-flex justify-content-between form-control mt-2">
            <span> شماره موبایل همراه</span>
            <span>{data && data.mobile}</span>
          </div>

          <div className="d-flex justify-content-between form-control mt-2">
            <span>کد ملی همراه</span>
            <span>{data && data.national_code}</span>
          </div>
        </div>
      );
    } else {
      return (
        <div
          key={coutn}
          className="d-flex justify-content-center form-control mt-2">
          <span>همراهی وجود ندارد</span>
        </div>
      );
    }
  });
};

const ShowDetailsReserve = ({ id, data }) => {
  const [state, setstate] = useState({ loading: true, data: null });
  useEffect(() => {
    handler();
  }, []);

  const renderType = (type) => {
    switch (type) {
      case "shift":
      case "shiftwcount":
        return detailsReserveFormDate;
      case "shiftwdate":
      case "shiftwdatewcount":
        return detailsReserveForm;
      case "sans":
      case "sanswcount":
      case "sanswcountwgender":
      case "sanswgender":
        return sansDetailsReserveForm;
    }
  };
  const handler = () => {
    setstate({ ...state, loading: true });
    getOrderDetails({
      order_id: data && data[0].id,
    }).then((response) => {
      setstate({ loading: false, data: response });
    });
  };
  const handlerModelorder = () => {
    switch (state.data.order.model_order) {
      case "reserve":
        return (
          <div className="">
            <Table
              title={"جزییات سفارش"}
              textEmpty={"سفارشی ثبت نشده است"}
              form={renderType(
                data &&
                  data[0] &&
                  data[0].item_reserve_product &&
                  data[0].item_reserve_product.type
              )}
              data={state.data.product}
              withOutShadow={false}
              noHeader={true}
            />
          </div>
        );
      case "joinclass":
        return (
          <div>
            <h4>اطلاعات کاربر</h4>
            <UserInfon data={state.data.user} />
            <h4>اطلاعات کلاس</h4>
            <ClassInfo data={state.data.product} />
            <h4>جزییات سفارش</h4>
            <OrderInfo data={state.data.order} />
            {"otheruser" in state.data && (
              <Fragment>
                <h4>اطلاعات همراه </h4>
                <OtherUserInfo data={state.data.otheruser} />
              </Fragment>
            )}
          </div>
        );
    }
  };

  return (
    <Fragment>
      {state.loading ? (
        <Loading count={1} col={12} height={200} />
      ) : (
        handlerModelorder(state.data)
      )}
    </Fragment>
  );
};
const ShowDetailsePayment = ({ id, data }) => {
  const [state, setstate] = useState({ loading: true, data: null });
  useEffect(() => {
    handler();
  }, []);

  const handler = () => {
    setstate({ ...state, loading: true });
    getOrderDetails({
      order_id: data && data[0].id,
    }).then((response) => {
      setstate({ loading: false, data: response.peyment });
    });
  };

  const renderTypePayment = (data) => {
    switch (data) {
      case "gateway":
        return "آنلاین";
      case "wallet":
        return "کیف پول";
      default:
        return data;
    }
  };

  const renderForm = (key) => {
    switch (key) {
      case "wallet":
        return detailsDataWallet;
      case "gateway":
        return detailsData;
      case "manager":
        return detailsManagerData;
      default:
        break;
    }
  };

  return (
    <Fragment>
      <div className="">
        {state.loading ? (
          <Loading count={1} col={12} height={200} />
        ) : (
          <Table
            title={"جزییات پرداخت"}
            textEmpty={"سفارشی ثبت نشده است"}
            form={renderForm(state.data && state.data.type_payment)}
            data={[state.data]}
            withOutShadow={false}
            noHeader={true}
          />
        )}
      </div>
    </Fragment>
  );
};
